var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVisa = function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.998 3.197c-.016 1.393 1.163 2.17 2.051 2.632.913.475 1.22.779 1.216 1.203-.007.649-.728.935-1.403.946-1.178.02-1.862-.339-2.406-.61l-.424 2.119c.546.268 1.557.503 2.605.513 2.461 0 4.071-1.297 4.08-3.309.01-2.552-3.307-2.693-3.284-3.834.008-.346.317-.715.994-.81.336-.047 1.262-.083 2.31.433L21.15.43A5.93 5.93 0 0 0 18.957 0c-2.317 0-3.946 1.315-3.959 3.197Zm10.11-3.02c-.45 0-.829.28-.998.71l-3.515 8.962h2.459l.49-1.444h3.005l.284 1.444H29L27.109.177h-2.002Zm.345 2.613.71 3.632h-1.944l1.234-3.632ZM12.016.177l-1.938 9.672h2.343L14.36.177h-2.343Zm-3.466 0L6.11 6.76l-.986-5.598C5.008.538 4.551.177 4.044.177H.055L0 .457c.819.19 1.749.496 2.312.823.345.2.443.375.557.85l1.868 7.72h2.477L11.011.176H8.55Z",
    fill: "#fff"
  })));
};
export default SvgVisa;